
import Vue from "vue";
import Component from "vue-class-component";
import {BModal} from "bootstrap-vue";
import DropdownSelector from "@/components/DropdownSelector.vue";
import {factory, HarbourOption, HarbourVisitModel, ResultError} from "@/api-client";
import {Prop} from "vue-property-decorator";
import toasts from "@/components/Toasts";

@Component({
    components: {
        DropdownSelector
    }
})
export default class HarbourVisitModal extends Vue {
    @Prop({required: true})
    harbourOptions!: HarbourOption[];

    model: HarbourVisitModel = factory.create(HarbourVisitModel);
    validationErrors: ResultError = factory.create(ResultError);

    $refs!: { bModal: BModal };

    mounted() {
        this.$refs.bModal.$on("show", () => this.reset());
    }

    private addVisit() {
        this.validateVisit(this.model);

        if (this.validationErrors.isEmpty) {
            this.$emit("add", this.model);
            this.hideModal();
            toasts.success(this.$ls.Global_Toast_AddSuccess);
        } else {
            this.setValidationErrors(this.validationErrors, this.$ls.Global_Toast_FormAddFailure);
        }
    }

    private hideModal() {
        this.$refs.bModal.hide();
    }

    private reset() {
        this.validationErrors.clear();
        this.model = factory.create(HarbourVisitModel);
        this.model.harbour = null;
    }

    private validateVisit(visit: HarbourVisitModel) {
        this.validationErrors.clear();

        if (!visit.harbour)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddHarbourVisit_Error_HarbourIsMandatory, 'harbour');

        if (!visit.enteredOn)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddHarbourVisit_Error_EntryDateIsMandatory, 'enteredOn');

        if (!visit.enteringPilot)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddHarbourVisit_Error_EntryPilotIsMandatory, 'enteringPilot');

        if (!visit.exitedOn)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddHarbourVisit_Error_ExitDateIsMandatory, 'exitedOn');

        if (!visit.exitingPilot)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddHarbourVisit_Error_ExitPilotIsMandatory, 'exitingPilot');

        if (this.validationErrors.hasMessages())
            return;

        if (visit.enteredOn! > visit.exitedOn!)
            this.validationErrors.appendMessage(this.$ls.Documents_Practices_Modal_AddHarbourVisit_Error_ExitMustBeLaterThanEntry, 'exitedOn');
    }
}
